import { defaultShouldDehydrateQuery } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'

import queryClient from '@/containers/query-client.ts'
import idbPersister from '@/containers/query-persister.ts'
import Root from '@/containers/Root.tsx'

const persistOptions = {
  persister: idbPersister,
  maxAge: 1000 * 60 * 60 * 24,
  dehydrateOptions: {
    shouldDehydrateQuery: (query: Parameters<typeof defaultShouldDehydrateQuery>[0]) =>
      defaultShouldDehydrateQuery(query) && query.meta?.persist === true,
  },
}

export function QueryClientProvider() {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <Root />
    </PersistQueryClientProvider>
  )
}
